<template>
  <v-container fluid v-resize="onResize" class="px-0 py-0">
    <v-card :height="componentHeight" :elevation="elevation" class="overflow-hidden" :width="componentWidth">
      <slot name="bar">
        <v-system-bar height="24">
          <slot name="bar.left" :editedItem="editedItem" :instance="instance"></slot>
          <v-breadcrumbs :items="breadsCrumbs()" v-if="!modalDialog" class="text-caption">
<!--            <template v-slot:divider>-->
<!--              <v-icon class="mx-0">mdi-chevron-right</v-icon>-->
<!--            </template>-->
          </v-breadcrumbs>
          <v-spacer></v-spacer>
          <slot name="bar.middle"></slot>
          <small small v-if="!!editedItem.prototype">
            <router-link :to="{name:'TaskTemplateItem', params: { itemUid: editedItem.prototype_uid}}">
              <span>ver. {{ editedItem.prototype_version }}</span>
            </router-link>
            <v-icon small class="ml-3">mdi-export</v-icon>
          </small>
          <v-chip small v-if="!!editedItem">{{ $t('version') }}: {{ editedItem.version }}</v-chip>
          <v-chip small v-if="!!editedItem">{{ $t('created') }}: {{ editedItem.created_by_name }}</v-chip>
          <v-chip small v-if="!!editedItem && !!editedItem.created_on">
            {{ editedItem.created_on | moment("DD.MM.YY HH:mm") }}
          </v-chip>
          <v-chip small v-if="!!editedItem">{{ $t('edited') }}: {{ editedItem.edited_by_name }}</v-chip>
          <v-chip small v-if="!!editedItem && !!editedItem.edited_on">{{
              editedItem.edited_on | moment("DD.MM.YY HH:mm")
            }}
          </v-chip>
          <!--        <v-chip small>{{ itemUid }}</v-chip>-->
          <v-divider vertical class="mx-3"></v-divider>
          <slot name="bar.right" :editedItem="editedItem" :instance="instance"></slot>
          <v-icon readonly @click="onHistoryActive()" :disabled="lockPage()">mdi-history</v-icon>
          <v-btn
              x-small
              plain
              :disabled="countBackup === 0"
              @click="restore()"
          >undo
          </v-btn>
          <BaseDeleteIcon :deleted="editedItem.deleted" :readonly="true" v-if="editedItem.deleted"></BaseDeleteIcon>
          <v-btn
              v-if="!!routeFullScreen"
              icon
              small
              :to="routeFullScreen"
          >
            <v-icon small>mdi-fullscreen</v-icon>
          </v-btn>
          <v-checkbox
              v-if="!!editedItem && !!pageProperty"
              v-model="pageProperty.lock_page"
              dense
              on-icon="mdi-lock-outline"
              off-icon="mdi-lock-open-variant-outline"
              class="mt-3"
          ></v-checkbox>
          <BaseDeleteIcon
              v-if="!!editedItem && !!pageProperty"
              v-model="editedItem.deleted"
              :readonly="pageProperty.lock_page"
              :show_label="false"
          ></BaseDeleteIcon>
          <BasePageMenu
              :page-properties="pageProperty"
              :fetch-action="fetchAction"
              :current-item="editedItem.uid"
              :selected-item-list="[editedItem]"
              :disabled="lockPage() || isDataChange"
          ></BasePageMenu>
        </v-system-bar>
      </slot>
      <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          top
      >
      </v-progress-linear>
      <v-row>
        <v-col cols="!!historyActive ? 10 : 12">
          <v-sheet
              :height="componentHeight - 60"
              class="my-0 py-5"
              :max-width="!!historyActive ? componentWidth * 10 / 12 - 100 : componentWidth">
            <slot
                name="body"
                :editedItem="editedItem"
                :editedItemCommon="editedItemCommon"
                :slotHeight="componentHeight - 60"
                :lockPage="lockPage()"
                :fetchAction="fetchAction"
                :changed="isDataChange || (!!editedItem.property_state && editedItem.property_state.error)"
                :instance="instance"
            >
            </slot>
          </v-sheet>
        </v-col>
        <v-col cols="2" v-if="!!historyActive">
          <HistoryList
              v-model="editedItem"
              :height="componentHeight - 135"
              class="my-0 py-5"
              rounded="0"
              :on-close="onCloseRestore"
              :on-restore="onRestore"
              :is-data-change="isDataChange"
              :dto-filter-restore-model="dtoFilterRestoreModel"
              :filter-restore-uid="editedItem.uid"
          >
          </HistoryList>
        </v-col>
      </v-row>
      <slot name="action">
        <v-toolbar height="36" class="mb-auto">
          <slot
              v-if="!historyActive"
              name="action.left"
              :editedItem="editedItem"
              :changed="isDataChange || (!!editedItem.property_state && editedItem.property_state.error)"
              :loading="commandLoading"
          ></slot>
          <v-spacer></v-spacer>
          <v-btn
              v-if="!noBtnCancel"
              text
              small
              elevation="3"
              class="mx-1"
              @click="onClose"
          >
            Close
          </v-btn>
          <v-btn
              text
              small
              elevation="3"
              class="mx-1"
              @click="onSave()"
              :disabled="!!historyActive || commandLoading || lockPage() || !isDataChange || (!!editedItem.property_state && editedItem.property_state.error)"
          >
            {{ $t('Save') }}
          </v-btn>
          <v-btn
              v-if="!noBtnSaveCancel"
              text
              small
              elevation="3"
              class="mx-1"
              @click="onSaveClose()"
              :disabled="!!historyActive || commandLoading || lockPage() || !isDataChange || (!!editedItem.property_state && editedItem.property_state.error)"
          >
            Save&Close
          </v-btn>
        </v-toolbar>
      </slot>
    </v-card>
    <ConfirmDialog :confirm_request="confirm_request" :fetch-request="fetchRequest"></ConfirmDialog>

    <v-dialog
        v-model="confirmDialog"
        max-width="450"
    >
      <v-card>
        <v-card-title class="text-h5">{{ $t('text_confirm_close_dialog') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="onConfirmDialog">
            {{ $t('btn_confirm_close_dialog') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseItemProperty from "@/components/Base/BaseItemProperty";
import commonFunction from "@/commonFunction/commonFunction"
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import HistoryList from "@/components/History/HistoryList";
import BaseConfirmBtn from "@/components/Base/BaseConfirmBtn";
import {debounce} from "debounce";
import BasePageMenu from "@/components/Base/BasePageMenu";


export default {
  name: 'BaseItem',
  props: {
    itemUid: {default: null},
    parentUid: {default: null},
    height: {default: null},
    width: {width: null},
    parentComponent: {type: [String], default: null},
    parentItemHref: {type: [String], default: null},
    parentItemName: {type: [String], default: null},
    dtoDetailModel: {type: [String], default: null},
    dtoSaveModel: {type: [String], default: null},
    dtoUpdateModel: {type: [String], default: null},
    dtoRestoreModel: {type: [String], default: null},
    dto_validate_model: {type: [String], default: null},
    dtoFilterRestoreModel: {type: [String], default: null},
    storeName: {type: [String], default: null},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    readonly: {type: [Boolean], default: false},
    dialog: {type: [Boolean], default: false},
    metadata: {default: null},
    noBtnCancel: {default: false},
    noBtnSaveCancel: {default: false},
    elevation: {default: 0},
  },

  components: {
    ConfirmDialog,
    BaseItemProperty,
    BaseDeleteIcon,
    HistoryList,
    BaseConfirmBtn,
    BasePageMenu,
  },

  computed: {
    ...commonFunction.mapDynamicGetters("storeName", ['getColumns', 'countBackup', 'isDataChange']),
    ...commonFunction.mapDynamicFields("storeName", [
      'editedItem', 'savedEditedItem', 'loading', 'commandLoading', 'confirm_request', 'editedItemCommon', 'dialogItem',
      'validateEditedItem', 'backupEditedStack', 'historyActive', 'pageProperty'
    ]),
    componentHeight() {
      if (!!this.height) {
        this.$emit('resize', this.height)
        return this.height
      }
      if (this.modalDialog) {
        this.$emit('resize', this.windowSize.y * 0.9)
        return this.windowSize.y * 0.9
      } else {
        this.$emit('resize', this.windowSize.y)
        return this.windowSize.y
      }
    },
    componentWidth() {
      if (!!this.width)
        return this.width
      return this.windowSize.x
    },

  },

  watch: {
    editedItem: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue)
        // if (!this.historyActive && JSON.stringify(newValue) !== JSON.stringify(oldValue))
        if (!this.historyActive) {
          this.validate(newValue)
        }
        this.$emit('change', newValue)
      },
      deep: true
    },
    itemUid: {
      handler(newValue, oldValue) {
        // console.log('watch itemUid')
        if (!this.modalDialog)
          this.fetchItem({
            itemUid: this.itemUid, dto_detail_model: this.dtoDetailModel, parentUid: this.parentUid,
            metadata: this.metadata
          })
      },
      deep: false
    },
    dialogItem: {
      handler(newValue, oldValue) {
        // console.log('watch dialogItem')
        if (newValue && this.modalDialog)
          this.fetchItem({
            itemUid: this.itemUid, dto_detail_model: this.dtoDetailModel, parentUid: this.parentUid,
            metadata: this.metadata
          })
      },
      deep: false
    },
    dialog: {
      handler(newValue, oldValue) {
        // console.log('watch dialog')
        if (newValue && this.modalDialog)
          this.fetchItem({
            itemUid: this.itemUid, dto_detail_model: this.dtoDetailModel, parentUid: this.parentUid,
            metadata: this.metadata
          })
      },
      deep: false
    },
  },

  methods: {
    ...commonFunction.mapDynamicActions("storeName", ['fetchItem', 'fetchAction',
      'fetchSaveEditedItem', 'fetchSaveCloseEditedItem', 'fetchRequest', 'fetchValidateItem', 'fetchRestoreEditedItem',
      'fetchSaveItemList']),

    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },
    restore() {
      // console.log('restore')
      this.fetchRestoreEditedItem()
    },

    lockPage() {
      return !(!this.historyActive && !!this.editedItem && !!this.pageProperty &&
          !this.pageProperty.lock_page && !this.readonly)
    },

    validate: debounce(function (newValue) {
      if (!!this.dto_validate_model && JSON.stringify(newValue) !== JSON.stringify(this.validateEditedItem)) {
        // console.log('validate', this.validateEditedItem)
        this.fetchValidateItem(this.dto_validate_model)
      }
    }, 500),

    emitValue() {
      // console.log('emitValue')
      this.$emit('update:editedItem', this.editedItem)
    },
    onSave() {
      this.fetchSaveEditedItem(this.dtoSaveModel)
      this.emitValue()
      this.$emit('save', this.editedItem)
    },
    onSaveClose() {
      this.fetchSaveCloseEditedItem({dto_save_model: this.dtoSaveModel, callback: this.onUnconditionalClose})
      this.emitValue()
      this.$emit('save', this.editedItem)
    },

    onUnconditionalClose() {
      // console.log('onUnconditionalClose', this.modalDialog, this.parentComponent, this.savedEditedItem)
      if (!this.modalDialog && !!this.parentComponent)
        this.$router.push({name: this.parentComponent})
      else {
        this.dialogItem = false
        this.editedItem = {}
        this.$emit('cancel', this.savedEditedItem)
      }
    },

    onClose() {
      console.log('onClose')
      if (this.isDataChange === false) {
        if (!this.modalDialog && !!this.parentComponent)
          this.$router.push({name: this.parentComponent})
        else {
          this.dialogItem = false
          this.editedItem = {}
          this.$emit('cancel', this.savedEditedItem)
        }
        console.log('onClose', this.dialogItem)
        return
      }
      if (window.confirm('Do you really want to leave? you have unsaved changes!')) {
        if (!this.modalDialog && !!this.parentComponent)
          this.$router.push({name: this.parentComponent})
        else {
          this.dialogItem = false
          this.editedItem = {}
          this.$emit('cancel', this.savedEditedItem)
        }
      }
    },

    onConfirmDialog() {
      // console.log('onConfirmDialog')
      this.dialogItem = false
      this.fetchItem({
        itemUid: this.itemUid, dto_detail_model: this.dtoDetailModel, parentUid: this.parentUid,
        metadata: this.metadata
      })
    },

    breadsCrumbs() {
      let parentRoute = this.$router.resolve({
        name: this.parentComponent
      });
      return [
        {text: 'Home', href: '/site/',},
        {text: parentRoute.route.name, href: parentRoute.href},
      ]
    },

    onHistoryActive() {
      this.historyActive = true
    },

    onRestore() {
      this.historyActive = false
      if (!!this.dtoRestoreModel) {
        this.fetchSaveEditedItem(this.dtoRestoreModel)
        this.emitValue()
      }
    },

    onCloseRestore() {
      this.historyActive = false
    },

  },

  async mounted() {
    // console.log('mounted BaseItem', this.dtoDetailModel, this.storeName, this.getColumns)
    await this.fetchItem({
      itemUid: this.itemUid, dto_detail_model: this.dtoDetailModel, parentUid: this.parentUid,
      metadata: this.metadata
    })
  },

  data() {
    return {
      subtractHeight: 95,
      windowSize: {x: 0, y: 0,},
      instance: this,
      valid: true,
      confirmDialog: false,
      self: this,
      labels: {
        btn: 'Update from prototype',
        confirm: 'OK',
        cancel: 'Cancel',
        text: 'Are you sure?',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "search": "Search",
    "Save": "Save",
    "Cancel": "Cancel",
    "new_item": "Add",
    "text_confirm_close_dialog": "Do you want to exit without saving?",
    "btn_confirm_close_dialog": "Are you sure?",
    "version": "version",
    "created": "created",
    "edited": "edited"
  },
  "de": {
    "search": "Suche",
    "Save": "Speichern",
    "Cancel": "Stornieren",
    "new_item": "Hinzufügen",
    "text_confirm_close_dialog": "Möchten Sie ohne Speichern beenden?",
    "btn_confirm_close_dialog": "Sind Sie sicher?",
    "version": "version",
    "created": "erstellt",
    "edited": "bearbeitet"
  }
}
</i18n>
